import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  Slide,
  Card,
  CardContent,
  TextField,
} from "@mui/material";

const EditSkillModal = ({
  open,
  handleClose,
  handleSave,
  tableApis,
  skillToEdit,
}) => {
  const [skillName, setSkillName] = useState("");

  // Set the initial skill name when the modal opens with a skill to edit
  useEffect(() => {
    if (skillToEdit) {
      setSkillName(skillToEdit.name || "");
    }
  }, [skillToEdit]);

  const handleSkillInputChange = (value) => {
    setSkillName(value);
  };

  const handleUpdateSkill = async () => {
    try {
      if (skillName.trim() === "") {
        alert("Please enter a skill name");
        return;
      }

      // Update the skill
      await tableApis.updateById(skillToEdit.id, { name: skillName });

      // Call the parent's save handler to refresh data and close modal
      handleSave();
    } catch (error) {
      console.error("Error updating skill:", error);
      alert("Failed to update skill. Please try again.");
    }
  };

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Slide direction="left" in={open}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "85%",
            height: "100%",
            bgcolor: "#f5f5f5",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography variant="h3" component="h2" sx={{ color: "#212121" }}>
              Edit Skill
            </Typography>
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{
                borderColor: "#bdbdbd",
                color: "#424242",
                "&:hover": {
                  borderColor: "#9e9e9e",
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              Close
            </Button>
          </Box>
          <Card
            sx={{
              p: 2,
              bgcolor: "#ffffff",
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
            }}
          >
            <CardContent>
              <Typography
                variant="h4"
                component="h3"
                sx={{
                  color: "#212121",
                  mb: 3,
                  fontWeight: 400,
                  borderBottom: "1px solid #e0e0e0",
                  paddingBottom: 2,
                }}
              >
                Edit Skill
              </Typography>

              <Box mb={3}>
                <Typography
                  variant="body1"
                  mb={1}
                  sx={{ color: "#212121" }}
                  fontWeight={400}
                >
                  Skill <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Skill Name"
                  value={skillName}
                  onChange={(e) => handleSkillInputChange(e.target.value)}
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover fieldset": {
                        borderColor: "#bdbdbd",
                      },
                    },
                    "& .MuiInputBase-input": {
                      color: "#424242",
                    },
                  }}
                />
              </Box>

              <Box
                display="flex"
                mt={4}
                gap={2}
                borderTop="1px solid #e0e0e0"
                pt={3}
              >
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#4285F4",
                    color: "white",
                    "&:hover": { bgcolor: "#3367D6" },
                    textTransform: "none",
                    fontWeight: 500,
                    paddingX: 4,
                    paddingY: 1,
                  }}
                  startIcon={<span style={{ fontSize: "16px" }}>✓</span>}
                  onClick={handleUpdateSkill}
                >
                  Save
                </Button>
                <Button
                  variant="text"
                  onClick={handleClose}
                  sx={{
                    color: "#757575",
                    "&:hover": {
                      bgcolor: "rgba(0, 0, 0, 0.04)",
                    },
                    textTransform: "none",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Slide>
    </Modal>
  );
};

export default EditSkillModal;
